import { useState, /*useRef,*/ useEffect } from 'react';
import Box from '@mui/material/Box';
import ComponentTable from '../../../Components/Table/Index';
import { Column } from '../../../Components/Table/Types';
import * as Icon from '@mui/icons-material/';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../../../shared/components/button/Button';
import { useSelector } from 'react-redux';
import CaixaLancamentoController from '../../../../controllers/CaixaLancamentoController';
import { Loader } from '../../../../shared/components/Loader';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import { toast } from 'react-toastify';
import { Home } from '../../../../routes/RoutesNames';
//import { toast } from 'react-toastify';
import FormBuilder from '../../../../shared/components/FormBuilder';

interface Row {
  cod: number;
  data_lancamento: string;
  origem_id: string;
  origem: string;
  valor_total: string;
  dinheiro: string;
  pix: string;
  status_pix: string;
  deposito: string;
  cheque: string;
  credito: string;
  debito: string;
  caixa_id: string;
  obs: string;
}

export default function CaixaLancamento() {
  //const ref = useRef<HTMLButtonElement>(null);
  const userId = useSelector((state: any) => state.Authentication.userId);
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);

  const tableColumns: Column[] = [
    { id: 'Codigo', label: 'Código', minWidth: 0, align: 'center', maxWidth: undefined },
    { id: 'DataLancamento', label: 'Data Lançamento', minWidth: 0, maxWidth: undefined },
    { id: 'OrigemId', label: 'Origem Id', minWidth: 0, maxWidth: undefined },
    { id: 'Origem', label: 'Origem', minWidth: 0, align: 'center', maxWidth: undefined },
    { id: 'ValorTotal', label: 'Valor Total', minWidth: 0, maxWidth: undefined },
    { id: 'Dinheiro', label: 'Dinheiro', minWidth: 0, maxWidth: undefined },
    { id: 'Pix', label: 'Pix', minWidth: 0, maxWidth: undefined },
    { id: 'StatusPix', label: 'Status Pix', minWidth: 0, align: 'center', maxWidth: undefined },
    { id: 'Deposito', label: 'Depósito', minWidth: 0, align: 'center', maxWidth: undefined },
    { id: 'Cheque', label: 'Cheque', minWidth: 0, align: 'center', maxWidth: undefined },
    { id: 'Credito', label: 'Crédito', minWidth: 0, align: 'center', maxWidth: undefined },
    { id: 'Debito', label: 'Débito', minWidth: 0, align: 'center', maxWidth: undefined },
    { id: 'CaixaId', label: 'Caixa Id', minWidth: 0, align: 'center', maxWidth: undefined },
    { id: 'Obs', label: 'Obs', minWidth: 0, align: 'center', maxWidth: undefined },
  ];

  const fields = [
    { name: 'DataInicio', type: 'date', label: 'Data Inicial' },
    { name: 'DataFinal', type: 'date', label: 'Data Final' },
    { type: 'submit', icon: (<Icon.Search style={{ fontSize: '28px' }} />) }
  ]

  const fieldsTotal = [
    { name: 'totalDinheiro', type: 'number', label: 'Total Dinheiro' },
    { name: 'totalDeposito', type: 'number', label: 'Total Depósito' },
    { name: 'totalDebito', type: 'number', label: 'Total Débito' },
    { name: 'totalPix', type: 'number', label: 'Total Pix' },
    { name: 'totalCheque', type: 'number', label: 'Total Cheque' },
    { name: 'totalCredito', type: 'number', label: 'Total Crédito' },
    { name: 'total', type: 'number', label: 'Total', col: 6 },

  ]

  const [tableRows, setTableRows] = useState<Row[]>([]);
  const [total, setTotal] = useState<any>({});

  // useEffect(() => {
  //   ref?.current?.click();
  // }, []);

  const handleNavigation = async (): Promise<void> => {
    navigate(Home, { replace: true })
    //navigate(-1)
  };

  const handleEditItem = (item: Row, duploClick = false, duploClickId = 0) => {
    //
  };

  const handleDeleteItem = async (cli_id: number) => {
    //
  };

  const handleSubmit = async (values: any) => {

    const DataRows: any = [];
    setLoading(true);
    const Response = await CaixaLancamentoController.Listar(values);
    setLoading(false);
    const responseValues = JSON.parse(String(Response?.Data?.[0]?.Lancamentos || '{}')) || {}

    const temLancamentos = responseValues?.lancamentos && responseValues.lancamentos.length > 0;

    if (!temLancamentos) {
      setTableRows([]);
      setTotal({});
      toast.info('Nenhum lançamento encontrado para o período selecionado.');
      return
    }

    toast.success('Lançamentos encontrados para o período selecionado.');
    
    // Campos Total
    setTotal(responseValues?.resumo?.[0] || null)

    // Tabela
    if (responseValues?.lancamentos && Array.isArray(responseValues.lancamentos)) {
      responseValues?.lancamentos?.forEach(item => {
        DataRows.push({
          Codigo: item.CaixaLancamentoID,
          StatusPix: item.STATUSPIX,
          CaixaId: item.TxId,
          Obs: (<div style={{ padding: '16px 0' }}>{item.cxl_OBS}</div>),
          OrigemId: item.cxl_OrigemId,
          ValorTotal: item.cxl_Valortotal,
          Credito: item.cxl_VlrCCredito,
          Debito: item.cxl_VlrCDeBito,
          Cheque: item.cxl_VlrCheque,
          Dinheiro: item.cxl_VlrDinheiro,
          Pix: item.cxl_VlrPix,
          DataLancamento: item.cxl_datalancamento,
          Origem: item.cxl_origem,
          Deposito: item.cxl_vlrDeposito,
          TipoLancamento: item.tipoLancamento
        });
      });
    }
    setTableRows(DataRows);

  };

  const initialValues = {
    DataInicio: '',
    DataFinal: '' // (new Date()).toISOString()
  };

  useEffect(() => {
    handleSubmit(initialValues);
  }, []);

  return (
    <Loader loading={loading}>
      <Box style={{ position: 'relative' }}>
        <HeaderComponent text={'Caixa Lançamento'}
          ButtonRight={
            <Button title={'Incluir'} variant='success' onClick={handleNavigation} iconStart={<Icon.Add />} />
          }
        />
        <Box style={{ display: 'flex', flexDirection: 'row', width: '280px', position: 'absolute', top: '87px', right: '-162px' }}>
          <Button variant='info' onClick={() => toast('Relatório em desenvolvimento')} title={'Relatório'} />
        </Box>

        <FormBuilder fields={fields} initialValues={initialValues} onSubmit={handleSubmit} />

        <ComponentTable columns={tableColumns} rows={tableRows} tableHeight={'max(50vh, 600px)'} style={{ padding: '100px 0' }} onRowDoubleClick={(row) => {
          handleEditItem(row, true, row.Id);
        }} />

        <FormBuilder fields={fieldsTotal} values={Object.keys(total).reduce((o, v) => ({ ...o, [v]: total?.[v] || '0' }), {})} gap='gap-4' />

      </Box>
    </Loader>
  );
}
